import { call, put, select, takeEvery } from 'redux-saga/effects';

import { Action, RequestWithEntity, Types } from '../ducks';
import { EndpointCreator, EntityWithId, IClient, ICreateActions } from '../interfaces';
import { getEndpoint } from './endpoint';

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function* create<T>(
  client: IClient<T>,
  endpointCreator: EndpointCreator,
  actions: ICreateActions<T>,
  id: string,
  entity: T,
  params?: { [key: string]: string },
) {
  yield put(actions.startCreate(id));

  const endpoint: string = yield select(getEndpoint, endpointCreator, params);
  if (!endpoint) {
    return yield put(actions.failCreate(id, "couldn't create endpoint"));
  }

  try {
    const returnedEntity: EntityWithId<T> = yield call([client, 'post'], `${endpoint}`, entity);
    return yield put(actions.completeCreate(id, returnedEntity));
  } catch (error) {
    return yield put(actions.failCreate(id, (error as Error).message));
  }
}

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function newCreateSaga<T, S>(
  client: IClient<T>,
  endpointCreator: EndpointCreator,
  actions: ICreateActions<T>,
  service: S,
) {
  const isCreateRequest = (action: Action<T, S>) =>
    action.type === Types.CREATE_REQUESTED && action.service === service;

  return function*() {
    yield takeEvery(isCreateRequest as any, (action: RequestWithEntity<T, S>) =>
      create<T>(client, endpointCreator, actions, action.payload.id, action.payload.entity, action.payload.params),
    );
  };
}
